import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  Text,
} from '@chakra-ui/react';
import {ChevronRightIcon} from '@chakra-ui/icons';
import {Link} from 'react-router-dom';

export interface CatalogMarketplaceBreadcrumbProps {
  crumbs: {name: string; link?: string; onClick?: () => void}[];
  textColor: string;
  headingTextColor: string;
}

const crumbLinkProps = {
  opacity: '0.8' as const,
  fontWeight: '400' as const,
  fontSize: 'sm' as const,
  lineHeight: '17px' as const,
  whiteSpace: 'nowrap' as const,
};

export const CatalogMarketplaceBreadcrumb: React.FC<
  CatalogMarketplaceBreadcrumbProps
> = ({crumbs, textColor, headingTextColor}) => (
  <Breadcrumb
    spacing='4px'
    listProps={{flexWrap: 'wrap'}}
    separator={
      <ChevronRightIcon
        color={textColor}
        opacity='0.8'
        flexShrink={0}
      />
    }
  >
    {crumbs.map((crumb, index) => (
      <BreadcrumbItem key={index}>
        {crumb.link !== undefined ? (
          <BreadcrumbLink
            as={Link}
            to={crumb.link}
            {...crumbLinkProps}
            color={textColor}
          >
            {crumb.name}
          </BreadcrumbLink>
        ) : crumb.onClick !== undefined ? (
          <BreadcrumbLink
            as='button'
            type='button'
            onClick={crumb.onClick}
            {...crumbLinkProps}
            color={textColor}
            bg='transparent'
            border='none'
            cursor='pointer'
            padding={0}
            _hover={{textDecoration: 'underline'}}
          >
            {crumb.name}
          </BreadcrumbLink>
        ) : (
          <Text
            fontWeight='700'
            fontSize='sm'
            color={headingTextColor}
            whiteSpace='nowrap'
          >
            {crumb.name}
          </Text>
        )}
      </BreadcrumbItem>
    ))}
  </Breadcrumb>
);
